import { motion } from "framer-motion";
import CloudContentLogo from "../assets/images/cc_logo_dark.png";

const LoadingOverlay = () => {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            data-testid="loading-overlay"
            className="fixed inset-0 z-[50] flex flex-col items-center justify-center bg-white/80 backdrop-blur-sm"
        >
            <img
                src={CloudContentLogo}
                width={150}
                alt=""
            />
            <div data-testid="progress-container" className="w-48 h-1 mt-6 bg-gray-200 rounded-full overflow-hidden">
                <div data-testid="progress-bar" className="h-full rounded-full animate-loading" style={{
                    background: 'linear-gradient(90deg, rgba(62,142,255,1) 0%, rgba(36,93,173,1) 35%)',
                }} />
            </div>
        </motion.div>
    );
}

export default LoadingOverlay;